import { configureStore } from '@reduxjs/toolkit';

import { loadHabitationState, saveHabitationState } from './habitationStorage';
import { loadRcState, saveRcState } from './rcStorage';
import { loadSanteMobiliteState, saveSanteMobiliteState } from './santeMobiliteStorage';
import { loadUserState, saveUserState } from './userStorage';
/* eslint-disable import/default */
import rootReducer from './reducers';
/* eslint-enable import/default */

const persistedState = {
  habitation: loadHabitationState(),
  rc: loadRcState(),
  santeMobilite: loadSanteMobiliteState(),
  user: loadUserState()
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

store.subscribe(() => {
  const state = store.getState();
  saveHabitationState(state.habitation);
  saveRcState(state.rc);
  saveSanteMobiliteState(state.santeMobilite);
  saveUserState(state.user);
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
export { store };
